"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataDictionary = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
const getDataDictionaryFields = (0, sonar_http_1.createGetEndpoint)((request) => {
    const { sonarObjectId } = request, rest = __rest(request, ["sonarObjectId"]);
    return `/api/v3/data-dictionary/fields/${sonarObjectId}?${(0, sonar_http_1.getQueryString)(rest)}`;
});
const getDataDictionaryByType = (0, sonar_http_1.createGetEndpoint)((request) => {
    const { sonarObjectType } = request, rest = __rest(request, ["sonarObjectType"]);
    return `/api/v3/data-dictionary/sonar-objects/types/${sonarObjectType}?${(0, sonar_http_1.getQueryString)(rest)}`;
});
const getDataDictionaryByApplication = (0, sonar_http_1.createGetEndpoint)((request) => {
    const { applicationId } = request, rest = __rest(request, ["applicationId"]);
    return `/api/v3/data-dictionary/applications/${applicationId}?${(0, sonar_http_1.getQueryString)(rest)}`;
});
const getDataDictionaryByTag = (0, sonar_http_1.createGetEndpoint)((request) => {
    const { tagId } = request, rest = __rest(request, ["tagId"]);
    return `/api/v3/data-dictionary/tags/${tagId}?${(0, sonar_http_1.getQueryString)(rest)}`;
});
const getDataDictionaryByComplianceCategory = (0, sonar_http_1.createGetEndpoint)((request) => {
    const { complianceCategory } = request, rest = __rest(request, ["complianceCategory"]);
    return `/api/v3/data-dictionary/compliance-categories/${complianceCategory}?${(0, sonar_http_1.getQueryString)(rest)}`;
});
const getDataDictionary = (request) => {
    if (request.sonarObjectId) {
        return getDataDictionaryFields(request);
    }
    else if (request.tagId) {
        return getDataDictionaryByTag(request);
    }
    else if (request.applicationId) {
        return getDataDictionaryByApplication(request);
    }
    else if (typeof request.complianceCategory === 'number') {
        return getDataDictionaryByComplianceCategory(request);
    }
    return getDataDictionaryByType(request);
};
exports.getDataDictionary = getDataDictionary;
//# sourceMappingURL=getDataDictionary.js.map